/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/import-keys/:key_id/test" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiImportKeysKeyIdTestCacheKeys } from "./constants";
import type {
  PostIntegrationsDirectCdiImportKeysKeyIdTestProps,
  IntegrationsDirectCdiImportKeysKeyIdTestResult,
} from "./types";

export const postIntegrationsDirectCdiImportKeysKeyIdTest = reactQueryMutationAdapter(
  integrationsDirectCdiImportKeysKeyIdTestCacheKeys,
  (
    props: PostIntegrationsDirectCdiImportKeysKeyIdTestProps
  ): Promise<IntegrationsDirectCdiImportKeysKeyIdTestResult> => {
    return fetch(`/integrations/direct/cdi/import-keys/${props.keyId}/test`, "POST", props);
  }
);
